/** Namespace `sharedHub` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const sharedHub = {
  "policy.strict.label": "Chặt",
  "policy.strict.body":
    "Mọi lần khách khai tài khoản đều phải chuyển 2.000đ TỪ chính tài khoản đó để chứng minh sở hữu. An toàn nhất.",
  "policy.lenient.label": "Thoáng",
  "policy.lenient.body":
    "Lần khai ĐẦU TIÊN của một số tài khoản được kết nối ngay, không cần chuyển tiền — miễn là chưa công ty nào khác từng khai số đó và Bube Bank Transfer Hub chưa từng thấy tin của số đó. Khai trùng vẫn phải xác minh; ai xác minh sau cùng được tính.",
  title: "Bube Bank Transfer Hub — chế độ khai",
  subtitle:
    "Khách bube-banktransfer chia sẻ biến động số dư tới máy của bube rồi khai số tài khoản trên dashboard. Chế độ này quyết lần khai nào phải chuyển 2.000đ xác minh.",
  loadFailed: "Không đọc được chế độ khai.",
  saveFailed: "Không đổi được chế độ khai.",
  hubLabel: "Bube Bank Transfer Hub: ",
  open: "Đang MỞ cho khách",
  closed: "Đang ĐÓNG",
  openHint: " — khách thấy « Chia sẻ biến động » trên dashboard bube-banktransfer và khai được tài khoản.",
  closedHint: " — khách không thấy « Chia sẻ biến động ». Máy hub vẫn nhận tin, nhưng không chia cho ai mới khai.",
  changing: "Đang đổi…",
  confirmClose: "Xác nhận ĐÓNG với khách",
  confirmOpen: "Xác nhận MỞ cho khách",
  closeForCustomers: "Đóng với khách",
  openForCustomers: "Mở cho khách",
  activeLabel: "Đang áp: ",
  defaultUntouched: " · mặc định, chưa ai chỉnh",
  changedAt: "· đổi lúc {at}",
  changedBy: " bởi {who}",
  lenientRisk:
    "Rủi ro: ai biết số tài khoản của một cửa hàng (in trên QR ở quầy) có thể khai TRƯỚC khi cửa hàng đó chia sẻ, và thấy tin tiền về của họ cho tới khi chủ thật xác minh. Tiền thật vẫn vào tài khoản của cửa hàng; lộ là thông tin giao dịch.",
  confirmSwitch: "Xác nhận chuyển sang « {policy} »",
  switchTo: "Chuyển sang « {policy} »",
  ownerOnly: "Chỉ vai chủ đổi được chế độ khai.",
  downgradeNote:
    "Đổi từ « Thoáng » sang « Chặt » không thu hồi các tài khoản đã kết nối khi khai lần đầu — chỉ áp cho lần khai sau.",

  "apk.title": "APK nội bộ « Bube Bank Transfer Hub »",
  "apk.body":
    "Bản cài cho Bube Bank Transfer Hub của bube — đọc được biến động số dư của MỌI khách chia sẻ tới máy. Chỉ dev tải; khách không có đường tải bản này. Máy hub đã cài tự cập nhật, chỉ cần tải khi cài máy mới.",
  "apk.loadFailed": "Không lấy được link tải.",
  "apk.notConfigured": "bube-banktransfer chưa cấu hình kho bản cài (R2) ở môi trường này.",
  "apk.noRelease": "Chưa phát hành bản hub nào.",
  "apk.version": "Bản ",
  "apk.meta": " (mã {code}) · {size} MB · phát hành {at}",
  "apk.download": "Tải {file}",
  "apk.expires": "Link hết hạn lúc {at} — hết hạn thì lấy link mới.",
  "apk.fetching": "Đang lấy link…",
  "apk.fetch": "Lấy link tải APK",

  "devices.title": "Máy hub",
  "devices.intro.pre":
    "Máy Android cài « Bube Bank Transfer Hub » nhận biến động số dư khách chia sẻ tới. Máy ghép bằng mã vào workspace hệ thống của bube-banktransfer",
  "devices.intro.post": ", rồi phải được duyệt ở đây mới nhận tin.",
  "devices.loadFailed": "Không đọc được danh sách máy hub.",
  "devices.codeFailed": "Không tạo được mã ghép.",
  "devices.decideFailed": "Không ghi được quyết định.",
  "devices.creatingCode": "Đang tạo mã…",
  "devices.createCode": "Tạo mã ghép máy hub",
  "devices.code": "Mã: ",
  "devices.codeExpires": " · hết hạn {at}",
  "devices.ownerOnly": "Chỉ vai chủ tạo mã ghép và duyệt máy hub.",
  "devices.pairHint": "Trên máy hub: mở Bube Bank Transfer Hub → nhập mã. Máy hiện bên dưới ở « Chờ duyệt ».",
  "devices.loading": "Đang tải…",
  "devices.empty": "Chưa có máy hub nào.",
  "col.device": "Máy",
  "col.paired": "Ghép lúc · IP",
  "col.heartbeat": "Nhịp tim",
  "col.listening": "Đang nghe",
  "col.status": "Trạng thái",
  noHeartbeat: "chưa có",
  unknownBank: " · chưa rõ ngân hàng",
  lastNotification: "tin cuối {at}",
  noNotification: "chưa có tin",
  "status.pending": "Chờ duyệt",
  "status.rejected": "Đã từ chối",
  "status.revoked": "Đã gỡ",
  "status.live": "Đang chạy",
  "status.stale": "Mất nhịp tim > 60 phút",
  "confirm.approve": "Duyệt ⇒ máy này đọc được biến động số dư của mọi khách chia sẻ tới. Chắc chắn?",
  "confirm.reject": "Từ chối ⇒ máy bị gỡ, phải ghép lại bằng mã mới.",
  "confirm.revoke":
    "Gỡ ⇒ máy thôi nhận tin ngay; ngân hàng chỉ máy này nghe sẽ tạm đóng với khách. Ghép lại phải dùng mã mới.",
  "action.approve": "Duyệt",
  "action.reject": "Từ chối",
  "action.revoke": "Gỡ",
  "action.approveEllipsis": "Duyệt…",
  "action.rejectEllipsis": "Từ chối…",
  "action.revokeEllipsis": "Gỡ…",
  // HQ-2026-007 — ô trạng thái bube-banktransfer ở thanh đầu trang.
  "svc.name": "BankTransfer",
  "svc.online": "Online",
  "svc.offline": "Offline",
  "svc.rejected": "Từ chối hub",
  "svc.notConfigured": "Chưa cấu hình",
  "svc.checking": "Đang kiểm…",
  "svc.unknown": "Không đọc được",
  "svc.devices": "{online}/{total} máy hub online",
  "svc.title.online": "Máy chủ bube-banktransfer trả lời ({ms} ms). Máy hub: {online} online · {offline} offline (im lặng quá {window} phút) · {pending} chờ duyệt. Kiểm lúc {at}.",
  "svc.title.down": "{reason} Kiểm lúc {at}.",
  "svc.title.unknown": "Hub không đọc được trạng thái: {reason}",
  "svc.cardTitle": "Trạng thái dịch vụ",
} as const;
